import {post, get} from '@/lib/axios';

const main_page = {
  async get_main() {
    return get(`/main_page`);
  },
};

export {main_page as default};
